import { plaintextValidator } from '../fields';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  subject: plaintextValidator(config),
  description: plaintextValidator(config)
};
